import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function AccountDeletion() {
  return (
    <LegalLayout title="Delete your account" effective="June 2026">
      <P>
        You can permanently delete your Pocket Docta account and associated data at any time. This
        page explains how, and what happens to your data.
      </P>

      <H2>How to delete your account in the app</H2>
      <UL items={[
        "Sign in to Pocket Docta.",
        "Open the Lifestyle Profile screen, or Care → Account.",
        'Tap "Delete all my data" and confirm.',
        "Your account and data are removed immediately, and you are signed out.",
      ]} />

      <H2>What gets deleted</H2>
      <P>
        Deleting your account permanently removes your health profile, uploaded documents, trips and
        reports, Care cases, specialist opinions, and consultation history. This action cannot be
        undone.
      </P>

      <H2>What we may retain</H2>
      <P>
        We may retain a limited amount of data where the law requires it — for example, payment and
        transaction records for accounting and tax purposes (typically 6 years), and Care case
        records where independent medical record-keeping obligations apply. Retained data is kept
        secure and is not used for any other purpose.
      </P>

      <H2>Prefer us to do it for you?</H2>
      <P>
        If you can't access your account, email us at info@pocketdocta.com from your registered email
        address and ask us to delete your account. We will verify your identity and complete the
        deletion, normally within 30 days.
      </P>
    </LegalLayout>
  );
}
